// = Libs =
import { FC, useEffect, useState } from 'react';

// = Styles =
// = Imports =
import {
  getReportQuestions,
  useReportQuestions,
  useReportSections,
} from '@/services/report.service';
import Answer from '@/pages/poll/componens/report/answer/answer';
import { QuestionModel, SectionModel } from '@/services/question.service';
import classes from './report.module.scss';
import { SplitContent } from '@/common/containers/split-content/split-content';
import { usePollList } from '@/services/poll.service';
import ReportActionPanel from '@/pages/poll/componens/report/report-action-panel/report-action-panel';

const Report: FC<{
  reportId: number;
  disabled?: boolean;
  confirmRequired?: boolean;
}> = (props) => {
  const { reportId, disabled = false, confirmRequired = true } = props;

  const sections = useReportSections(reportId) || [];
  const [trigger, setTrigger] = useState(0);
  const [questions, setQuestions] = useState(
    useReportQuestions(reportId) || []
  );

  const [isFull, setFull] = useState(true);

  const polls = usePollList({
    mode: 'author',
    limit: 1000,
    offset: 0,
    mapping: (el) => ({
      value: el.pollId,
      label: el.title,
    }),
  })?.elementList;

  useEffect(() => {
    const fetchData = async () => {
      let qs = (await getReportQuestions(reportId)).data?.items;
      setQuestions(qs);
      return qs;
    };
    fetchData().then((qs) => {
      let flag = true;
      qs?.forEach((q: QuestionModel) => {
        if (!q?.answer?.value || q?.answer.value === 0) {
          flag = false;
        }
      });
      setFull(flag);
    });
  }, [trigger]);

  const sectionedQuestions = sections?.map((section: SectionModel) => {
    return {
      sectionId: section?.sectionId,
      sectionTitle: section?.title,
      questions: questions?.filter(
        (q: QuestionModel) => q?.sectionId === section?.sectionId
      ),
    };
  });

  return (
    <SplitContent
      Position={true}
      SideBar={
        <ReportActionPanel
          reportId={reportId}
          disabled={!isFull}
          canSubmit={!disabled}
          confirmRequired={confirmRequired}
        />
      }
      Content={
        <div className={classes['section-container']}>
          {sectionedQuestions?.map((s) => (
            <div className={classes.section}>
              <h3>{s.sectionTitle}</h3>
              <div className={classes['question-container']}>
                {s.questions?.map((q) => (
                  <Answer
                    reportId={reportId}
                    question={q}
                    trigger={() => {
                      setTrigger(trigger + 1);
                    }}
                    disabled={disabled}
                    polls={polls}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      }
    />
  );
};

export default Report;
